import React, { useState } from 'react';
import { setAdminCredentials, clearAdminCredentials, adminProductsAPI } from '../../services/api';

const AdminLogin = ({ onSuccess }) => {
  const [username, setUsername] = useState('znsolar_admin');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      setError(null);
      // Save credentials (Basic Auth). We will verify with a small call later in Admin page.
      setAdminCredentials(username, password);
      onSuccess();
    } catch (err) {
      setError('Identifiants invalides');
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white border rounded-xl p-6 shadow-md">
      <h2 className="text-xl font-bold mb-4">Connexion Administrateur</h2>
      <form onSubmit={handleLogin} className="space-y-4">
        <div>
          <label className="block text-sm text-gray-700 mb-1">Nom d'utilisateur</label>
          <input 
            type="text"
            value={username} 
            onChange={(e) => setUsername(e.target.value)} 
            placeholder="znsolar_admin"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500"
          />
        </div>
        <div>
          <label className="block text-sm text-gray-700 mb-1">Mot de passe</label>
          <input 
            type="password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            placeholder="••••••••"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500"
          />
        </div>
        {error && <div className="text-red-600 text-sm">{error}</div>}
        <button 
          type="submit" 
          className="w-full bg-yellow-600 text-black py-2 px-4 rounded-md hover:bg-yellow-700 transition-colors"
        >
          Se connecter
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;